import {
  VStack,
  Text,
  Flex,
  Box,
  Divider,
  Checkbox,
  Collapse,
  Stack,
} from "@chakra-ui/react";
import React, { useCallback, useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import FooterPmsSearch from "../../navigation/footer/FooterPmsSearch";
import SearchFormHeader from "../../practitioner-search/SearchFormHeader";
import {
  incrementPmsSearchStep,
  decrementPmsSearchStep,
} from "../../redux/actions/layout";
import { updatePmsSearchDetails } from "../../redux/actions/pmsSearch";
import Lozenge from "../../components/common/Lozenge";
import PMSNavButtons from "./PMSNavButtons";
import RangeSliderInput from "../../components/forms/RangeSliderInput";
import { LocationSearch } from "../../practitioner-search/LocationSearch";
import { useUtilityData } from "../../utilities/contexts";
import {
  renderAvailabilityContent,
  sectionStyleEditing2,
} from "../../utilities/render-helpers/renderPractitionerProfile";
import { useUtilityDataSelector } from "../../utilities/contexts";

const PmsSearchSessionDetailsForm = (props) => {
  const pmsSearch = useSelector((state) => state.pmsSearch);
  const utilityData = useUtilityData();
  const dispatch = useDispatch();
  const formSessionDetails = useRef();

  const { availability: availabilityLabels } = props.utilData;

  // Get the availability data
  const [availability, setAvailability] = useState(
    pmsSearch.availability || [
      [false, false, false, false, false, false, false],
      [false, false, false, false, false, false, false],
      [false, false, false, false, false, false, false],
      [false, false, false, false, false, false, false],
      [false, false, false, false, false, false, false],
    ]
  );

  const handleAvailabilityUpdate = useCallback((value) => {
    setShowAvailabilityError(false);
    setAvailability(value);
  }, []);

  const [sessionTypes, setSessionTypes] = useState([]);
  const [disabledAccess, setDisabledAccess] = useState([
    { value: 1, label: "Yes" },
    { value: 2, label: "No", selected: true },
  ]);
  const [openCollapse, setOpenCollapse] = useState(false);
  const [chkLocationHome, setChkLocationHome] = useState(
    pmsSearch.homeAddress?.length ?? ""
  );
  const [chkLocationOffice, setChkLocationOffice] = useState(
    pmsSearch.officeAddress?.length ?? ""
  );
  const [chkLocationOther, setChkLocationOther] = useState(
    pmsSearch.otherAddress?.length ?? ""
  );
  const [homeAddress, setHomeAddress] = useState(pmsSearch.homeAddress || "");
  const [officeAddress, setOfficeAddress] = useState(
    pmsSearch.officeAddress || ""
  );
  const [otherAddress, setOtherAddress] = useState(
    pmsSearch.otherAddress || ""
  );
  const [homeZip, setHomeZip] = useState(pmsSearch.homeZip || "");
  const [officeZip, setOfficeZip] = useState(pmsSearch.officeZip || "");
  const [otherZip, setOtherZip] = useState(pmsSearch.otherZip || "");
  const [homeLocation, setHomeLocation] = useState(
    pmsSearch.homeLocation || {}
  );
  const [officeLocation, setOfficeLocation] = useState(
    pmsSearch.officeLocation || {}
  );
  const [otherLocation, setOtherLocation] = useState(
    pmsSearch.otherLocation || {}
  );

  //slider
  const [maxBudget, setMaxBudget] = useState(pmsSearch.maxBudget || 250);
  const [minBudget, setMinBudget] = useState(pmsSearch.minBudget || 0);

  const [loaded, setLoaded] = useState(false);
  const { sessionTypes: allSessionTypes } = props.utilData;

  const [showSessionError, setShowSessionError] = useState(false);
  const [showAvailabilityError, setShowAvailabilityError] = useState(false);

  useEffect(() => {
    // initalise form
    // pms Search will have full arrays
    pmsSearch.sessionTypes?.length > 0
      ? setSessionTypes(pmsSearch.sessionTypes)
      : setSessionTypes(allSessionTypes);

    setLoaded(true);
  }, [allSessionTypes, pmsSearch]);

  useEffect(() => {
    // clear location is Online chosen
    if (sessionTypes?.filter((type) => type.selected)[0]?.label === "Online") {
      setChkLocationHome(false);
      setChkLocationOffice(false);
      setChkLocationOther(false);
      setHomeAddress("");
      setOfficeAddress("");
      setOtherAddress("");
      setHomeLocation({ lat: null, lng: null });
      setOfficeLocation({ lat: null, lng: null });
      setOtherLocation({ lat: null, lng: null });
      setHomeZip("");
      setOfficeZip("");
      setOtherZip("");
    }
    // show location if In Person is chosen
    if (
      sessionTypes?.filter((type) => type.selected)[0]?.label === "In person"
    ) {
      setOpenCollapse(true);
    } else {
      setOpenCollapse(false);
    }
    setLoaded(true);
  }, [sessionTypes]);

  const checkSessionTypes = () => {
    let hasSelectedSessionType = false;
    sessionTypes.forEach((type) => {
      if (type.selected) {
        hasSelectedSessionType = true;
      }
    });
    setShowSessionError(!hasSelectedSessionType);
    return hasSelectedSessionType;
  };

  const checkAvailability = () => {
    let usesAvailability = false;
    for (const time of availability) {
      if (usesAvailability) {
        break;
      }

      for (const day of time) {
        if (day) {
          usesAvailability = true;
          break;
        }
      }
    }
    setShowAvailabilityError(!usesAvailability);
    return usesAvailability;
  };

  const handleClickPrev = () => {
    submit("prev");
  };

  const handleClickNext = () => {
    const hasSelectedSessionType = checkSessionTypes();
    const hasSelectedAvailability = checkAvailability();

    if (hasSelectedSessionType && hasSelectedAvailability) {
      submit("next");
    }
  };

  const submit = (direction) => {
    const values = {};

    values.sessionTypes = sessionTypes;

    // set rangeSlider
    values.maxBudget = maxBudget;
    values.minBudget = minBudget;
    values.homeZip = { value: homeZip, ...homeLocation };
    values.officeZip = { value: officeZip, ...officeLocation };
    values.otherZip = { value: otherZip, ...otherLocation };
    values.homeAddress = homeAddress;
    values.officeAddress = officeAddress;
    values.otherAddress = otherAddress;
    values.homeLocation = homeLocation;
    values.officeLocation = officeLocation;
    values.otherLocation = otherLocation;
    values.availability = availability;
    values.disabledAccess = disabledAccess;

    dispatch(updatePmsSearchDetails(values));
    direction === "next"
      ? dispatch(incrementPmsSearchStep())
      : dispatch(decrementPmsSearchStep());
  };

  // Wait for state to load
  if (!loaded) return null;

  // Render
  return (
    <div>
      <Box width="100%" maxW="container.sm" mx="auto" mb="120px" pt="24px">
        <SearchFormHeader />
        <VStack
          as="form"
          maxW="full"
          py={7}
          px={5}
          //mx="auto"
          spacing={8}
          alignItems="flex-start"
          bg="white"
          borderRadius={{ base: 0, md: 20 }}
          boxShadow="lg"
          overflow="hidden"
        >
          <Lozenge
            title="How would you like to carry out your sessions?"
            data={sessionTypes}
            onclick={(e) => {
              setSessionTypes(e);
              setShowSessionError(false);
            }}
            required={true}
            error={showSessionError}
          />
          <Collapse style={{ width: "100%" }} in={openCollapse} animateOpacity>
            <VStack bg="teal" padding="20px" borderRadius="10px" color="white">
              <Text alignSelf="flex-start">
                Let us know which locations work for you so we can find
                therapists nearby in that area
              </Text>
              <div className="flex flex-col w-full text-brand-text">
                <span className="text-white">Home</span>
                <LocationSearch
                  initialLocation={homeAddress}
                  onChangeLocation={(name, location, postcode) => {
                    setHomeAddress(name);
                    setHomeLocation(location);
                    setHomeZip(postcode);
                  }}
                />
              </div>
              <div className="flex flex-col w-full text-brand-text">
                <span className="text-white">Office</span>
                <LocationSearch
                  initialLocation={officeAddress}
                  onChangeLocation={(name, location, postcode) => {
                    setOfficeAddress(name);
                    setOfficeLocation(location);
                    setOfficeZip(postcode);
                  }}
                />
              </div>
              <div className="flex flex-col w-full text-brand-text">
                <span className="text-white">Other</span>
                <LocationSearch
                  initialLocation={otherAddress}
                  onChangeLocation={(name, location, postcode) => {
                    setOtherAddress(name);
                    setOtherLocation(location);
                    setOtherZip(postcode);
                  }}
                />
              </div>

              <Box
                bg="white"
                width="100%"
                marginTop="20px"
                padding="8px"
                borderRadius="5px"
              >
                <Lozenge
                  title="Would you need disabled access?"
                  data={disabledAccess}
                  onclick={setDisabledAccess}
                />
              </Box>
            </VStack>
          </Collapse>
          <Divider />
          <Box w="100%">
            <Flex
              flexDirection="row"
              width="100%"
              justifyContent="space-between"
              alignItems="center"
            >
              <Text textStyle="h6">
                What&apos;s your approximate budget per session?{" "}
              </Text>
              <Text textStyle="h4">
                £{minBudget} - £{maxBudget}
              </Text>
            </Flex>

            <RangeSliderInput
              min="0"
              max="250"
              defMin={minBudget}
              defMax={maxBudget}
              sliderValue={[minBudget, maxBudget]}
              onchange={(val) => {
                setMinBudget(val[0]);
                setMaxBudget(val[1]);
              }}
              onchangeend={(val) => {
                setMinBudget(val[0]);
                setMaxBudget(val[1]);
              }}
              type="cash"
            />
          </Box>
          <Divider />
          <Stack direction="column" width="100%">
            <Text className="relative pl-3">
              <span className="text-red-500 absolute left-0 top-0">*</span>When
              could you see your practitioner?
            </Text>
            <Text textStyle="footer2" color="brand.200" paddingBottom="8px">
              Please include day time availability if you can
            </Text>
            <Text textStyle="footer2" color="brand.200" paddingBottom="8px">
              Many therapists do not work at the weekends
            </Text>
            <Box sx={sectionStyleEditing2}>
              <Box
                position="relative"
                className={
                  showAvailabilityError &&
                  "ring-2 ring-offset-4 ring-red-500 rounded-sm"
                }
              >
                <VStack alignItems="flex-start">
                  <Box w="100%">
                    {renderAvailabilityContent(
                      availabilityLabels,
                      availability,
                      handleAvailabilityUpdate
                    )}
                  </Box>
                </VStack>
              </Box>
              {showAvailabilityError && (
                <span className="text-red-500 text-xs pt-2">
                  Please select your preferred times for a session
                </span>
              )}
            </Box>
          </Stack>

          <Box h="24px" w="100%"></Box>
          <PMSNavButtons
            handleClickNext={handleClickNext}
            handleClickPrev={handleClickPrev}
          />
          <FooterPmsSearch
            handleClickNext={handleClickNext}
            handleClickPrev={handleClickPrev}
          />
        </VStack>
      </Box>
      {/* Footer */}
    </div>
  );
};

export default PmsSearchSessionDetailsForm;
